import './Footer.css';

const Footer = () => {
    // return the footer code
    return <div id="footer"></div>;
};

export default Footer;
